// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"p0-z","subtitle":"q0-z","wrapper":"r0-z","leftArrow":"s0-z","rightArrow":"t0-z"};